import Joi from "joi";
import ClassSchema from "../ClassSchema";
import { IValidationErrors } from "features/common/Interfaces";
import { IRecords, IClassRecord } from "../AddingIndividually";

export function validateProperty({
  name,
  value,
}: {
  name: "className" | "gradeId" | "teacherId";
  value: string;
}) {
  const obj = { [name]: value };
  const propertySchema = {
    [name]: ClassSchema[name],
  };
  const { error } = Joi.object(propertySchema).validate(obj);
  return error ? error.details[0].message : null;
}

export function validate(formData: IClassRecord, errors: IValidationErrors) {
  const options = { abortEarly: false };
  const { className, gradeId, teacherId } = formData;
  const { error } = Joi.object(ClassSchema).validate(
    { className, gradeId, teacherId },
    options
  );
  let errorsObject = { ...errors };
  if (error)
    for (let item of error.details) errorsObject[item.path[0]] = item.message;
  return errorsObject;
}

export const removeExtraEmptyRecord = (
  record: IRecords[],
  initialRecord: () => IRecords
) => {
  const originRecords = JSON.parse(JSON.stringify(record)) as IRecords[];
  const updatedRecords: IRecords[] = [];
  originRecords.forEach((record) => {
    if (record.data.className.length) updatedRecords.push(record);
  });
  if (!updatedRecords.length) {
    updatedRecords.push(
      JSON.parse(JSON.stringify(initialRecord())) as IRecords
    );
    return updatedRecords;
  }
  const onlyOneEmptyRecord = originRecords.length <= updatedRecords.length + 1;
  return onlyOneEmptyRecord ? originRecords : updatedRecords;
};
